import { Component, SimpleChanges, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { AuthGuardService, CommercialService, UserService } from '@core/services';
import { User } from '@shared/models';

@Component({
  selector: 'app-program-detail',
  templateUrl: './program-detail.component.html',
  styleUrls: ['./program-detail.component.css']
})
export class ProgramDetailComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  user: User;

  @Input()
  program_type_id: number;
  @Input()
  hideDetailLink = false;

  private commercialSubscription: Subscription;
  private commercial: any;
  public showDetails = false;
  subscription: Subscription;

  private allowAutoReplenish: string;
  private cardReplacementFee: string;
  private cardsAllowed: string;
  private currency: string;
  private newCardFee: string;
  private nsfCharge: string;
  private programFee: string;
  private programId: string;
  private programName: string;
  private renewalBonus: string;
  private replenishmentAmount: string;
  private replenishmentThreshold: string;
  private signUpBonus: string;
  private suppliedFee: string;
  private tripCost: string;
  private tripCostTemp: string; // Temp fix for toll cost difference.

  linkContextString = 'View';

  constructor(private _authGuard: AuthGuardService, private _userService: UserService, private _commercial: CommercialService) { }

  ngOnInit() {
    this.commercialSubscription = this._commercial.getCommercialValue().subscribe(commercial => this.commercial = commercial);
    this.subscription = this._userService.getUser().subscribe(user => {
      this.user = user;
      console.log(user)
      if (user.accountSummaryArray) {
        if (user.accountSummaryArray.length > 0) {
          console.log('Getting programs');
          this.getPrograms();
        }
      } else if (this.program_type_id) {
        console.log('Injected project_type_id', this.program_type_id);
          this._commercial.setAccountCommercialByInput(this.program_type_id);
          this.getPrograms();
      }
    });

  }
  ngOnChanges(changes: SimpleChanges) {
    console.log('Something changed')
    console.log(changes)
    console.log(this.user)
    if(changes.program_type_id){
      this.program_type_id = changes.program_type_id.currentValue;
      this.getPrograms();
    }
    if (this.user)
      if (this.user.accountSummaryArray) {
        if (this.user.accountSummaryArray.length > 0) {
          this.getPrograms();
        } else if (changes.program_type_id) {
          this._commercial.setAccountCommercialByInput(this.program_type_id);
          this.getPrograms();
        }
      }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.commercialSubscription.unsubscribe();
  }

  getPrograms() {
    let programArray: any;
    this._authGuard.authenticatedPost('portfolios/ProgramTypes2', this.setUpProgramsData()).subscribe(
      result => {
        programArray = result;
        console.log('programs', programArray);
        if (programArray.length > 0) {
          let programDetails = programArray[0];
          if (programDetails.allowautoreplenish) {
            this.allowAutoReplenish = 'On';
          } else {
            this.allowAutoReplenish = 'Off';
          }
          this.programName = programDetails.programname;

          this.cardReplacementFee = programDetails.cardreplacementfee.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          this.cardsAllowed = programDetails.cardsallowed.toString();
          this.currency = programDetails.currencyname;
          this.newCardFee = programDetails.newcardfee.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          this.nsfCharge = programDetails.nsfcharge.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          if (programDetails.tripcostdplaza && programDetails.tripcostwplaza) {
            this.tripCost = programDetails.tripcostdplaza.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            this.tripCostTemp = "";
            this.tripCostTemp = this.tripCost +" (D)";
            this.tripCostTemp += "/";
            this.tripCostTemp += programDetails.tripcostwplaza.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            this.tripCostTemp += " (W)";
          }
            // if (this.currency == "Canada" &&
            //       (
            //         (this.programName == "Passenger - Nexpress" || this.programName == "Nexpress Toll - CDN") ||
            //         this.tripCost == "3.95"
            //       )
            //     ) {
            //   this.tripCostTemp = "$3.95/ 4.20"; // First Attempt.
            // }
            console.log("<" + this.tripCostTemp + "> <" + this.programName + "> <" + this.currency + ">");
          if(programDetails.replenishmentamount){
            // if(programDetails.replenishmentamount == 40){
            //   this.tripCostTemp = "$4.75/$5.30"
            // }
            this.replenishmentAmount = programDetails.replenishmentamount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            this.replenishmentThreshold = programDetails.replenishmentthreshold.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          }
          if (this.user.accountSummaryArray) {
            if (this.user.accountSummaryArray.length > 0) {
              this.replenishmentAmount = this.user.accountSummaryArray[this.user.accountIndex].ReplenishmentAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

              this.replenishmentThreshold = this.user.accountSummaryArray[this.user.accountIndex].ReplenishmentThreshold.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            } else {

              this.replenishmentAmount = programDetails.replenishmentamount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
              this.replenishmentThreshold = programDetails.replenishmentthreshold.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

            }
          }

          if(this.hideDetailLink){
            this.showDetails = true;
          }
        }
      },
      error => {
        console.log(error);
      }
    );

  }

  setUpProgramsData() {
    let currentAccount;
    let programId;
    if(this.program_type_id){
      programId = this.program_type_id
    }
    if (this.user.accountSummaryArray) {
      if (this.user.accountSummaryArray.length > 0) {
        currentAccount = this.user.accountSummaryArray[this.user.accountIndex];
        if(this.program_type_id){
          programId = this.program_type_id
        } else {
          programId = currentAccount.ProgramType;
        }
      } else if (this.program_type_id) {
        programId = this.program_type_id;
      }

    }
    let hideWeb = false;
    if (!this.commercial.isCustomerCommercial && !this.commercial.isAccountCommercialPrimary) {
      hideWeb = true;
    }
    console.log('program type id injected ', this.program_type_id);
    console.log('commercial: ', this.commercial);
    return {

      'ProgramId': programId,
      'HideNonWebPrograms': hideWeb,
      'IsCommercial': this.commercial.isAccountCommercialPrimary

    };

  }

  toggleDetails() {
    this.showDetails = !this.showDetails;
    if (this.showDetails) {
      this.linkContextString = 'Hide';
    } else {
      this.linkContextString = 'View';
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/program-detail/program-detail.component.ts